<template>
    <div>
        <slot name="title"></slot>
        <h5 class="text-primary text-center">{{ $t('finalevaluation.treatments') }}</h5>

        <input-field
            v-model="amchafibrin_dose"
            :field="finalEvaluationFields.amchafibrim_dose"
            :inline="false"
            :placeholder="$t('textarea.placeholder')"
            field-name="amchafibrin-dose"
            form-width="auto"
            no-center-text
            class="mb-3"
        />

        <input-field
            v-model="caproamin_dose"
            :field="finalEvaluationFields.caproamin_dose"
            :inline="false"
            :placeholder="$t('textarea.placeholder')"
            field-name="caproamin-dose"
            form-width="auto"
            no-center-text
            class="mb-3"
        />

        <input-field
            v-model="prophylaxis_with_hbpm"
            :field="finalEvaluationFields.prophylaxis_with_hbpm"
            :inline="false"
            :placeholder="$t('textarea.placeholder')"
            field-name="prophylaxis-with-hbpm"
            form-width="auto"
            no-center-text
            class="mb-3"
        />

        <input-field
            v-model="prophylaxis_mechanical"
            :field="finalEvaluationFields.prophylaxis_mechanical"
            :inline="false"
            :placeholder="$t('textarea.placeholder')"
            field-name="prophylaxis-mechanical"
            form-width="auto"
            no-center-text
            class="mb-3"
        />

        <text-area-field
            v-model="treament_others"
            :field="finalEvaluationFields.treament_others"
            field-name="treament-others"
            class="mb-3"
        />

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import InputField from "@/components/fields/InputField";
    import NavigableComponentMixin from "@/components/mixins/NavigableComponentMixin";
    import TextAreaField from "@/components/fields/TextAreaField";

    export default {
        name: "FinalEvaluationTreatments",
        components: {TextAreaField, InputField},
        mixins: [NavigableComponentMixin],
        computed: {
            ...mapState([
                'finalEvaluationFields',
            ]),
            ...mapStateProperty([
                'finalEvaluation.amchafibrin_dose',
                'finalEvaluation.caproamin_dose',
                'finalEvaluation.prophylaxis_with_hbpm',
                'finalEvaluation.prophylaxis_mechanical',
                'finalEvaluation.treament_others',
            ]),
        },
         methods: {
            validate() {
                return true;
            },
            back() {

            },
        },
    };
</script>

<style scoped>

</style>